module.exports = __webpack_public_path__ + "0ab107555ecd0428e8919e325a97d142.svg";